import { connect } from 'react-redux';
import * as R from 'ramda';

// Component
import RackWaitTimes from './RackWaitTimes';

// Functions
import { getItem, setMobileDrawerOpen } from './store/rackWaitTimesSlice';

const mapState = R.applySpec({
  mobileDrawerOpen: getItem('mobileDrawerOpen'),
});

const mapDispatchToProps = {
  setMobileDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(RackWaitTimes);
